export const sortStringAndBooleanValues = (event, data) => {
  return data.sort((objectA, objectB) => {
    if (event.detail.key === 'updatedBy') {
      let keyNameOne = !objectA[event.detail.key] ? 'createdBy' : event.detail.key;
      let keyNameTwo = !objectB[event.detail.key] ? 'createdBy' : event.detail.key;
      return objectA[keyNameOne]?.toLowerCase() < objectB[keyNameTwo]?.toLowerCase() ? -1 : 1;
    } else {
      if (event.detail.key === 'status') {
        return objectA['isActive'] < objectB['isActive'] ? 1 : -1;
      } else {
        const makeLowerCaseValue = (value) => typeof value === "string" ? value?.toLowerCase() : value;
        return makeLowerCaseValue(objectA[event.detail.key]) < makeLowerCaseValue(objectB[event.detail.key]) ? -1 : 1;
      }
    }
  });
};

export const sortDateValues = (event, data) => {
  return data.sort((objectA, objectB) => {
    if (event.detail.key == 'updatedAt') {
      let keyNameOne = !objectA[event.detail.key] ? 'createdAt' : event.detail.key;
      let keyNameTwo = !objectB[event.detail.key] ? 'createdAt' : event.detail.key;
      return new Date(objectA[keyNameOne]) - new Date(objectB[keyNameTwo]);
    } else {
      return new Date(objectA[event.detail.key]) - new Date(objectB[event.detail.key]);
    }
  });
};

export const sortNumber = (data, key, dir) => {
  return data.sort((a, b) => {
    if (dir === 'desc') {
      return b[key] - a[key];
    }
    return a[key] - b[key];
  });
};

export const sortString = (data, key, dir) => {
  return data.sort((a, b) => {
    let x = a[key].toLowerCase();
    let y = b[key].toLowerCase();
    if (dir === 'desc') {
      if (x > y) { return -1; }
      if (x < y) { return 1; }
    } else {
      if (x > y) { return 1; }
      if (x < y) { return -1; }
    }
    return 0;
  });
};

export const sortDate = (data, key, dir) => {
  return data.sort((a, b) => {
    if (dir === 'desc') {
      return new Date(b[key]) - new Date(a[key]);
    } else {
      return new Date(a[key]) - new Date(b[key]);
    }
  });
};
